export default "__VITE_ASSET__B$i3z8Np__"